import { css } from 'styled-components';
import { colors } from '../../atoms/colors/colors';
import { spacing } from '../../atoms/spacing/spacing';
import { BannerTags } from './class-name-tags';
export const commonTheme = {
    base: css `
    display: flex;
    align-items: flex-start;
    justify-items: flex-start;
    color: ${colors.coolgrey600};
    padding: ${spacing.spacing16};
    padding-right: ${spacing.spacing32};

    & .${BannerTags.iconWrapper} {
      margin-right: ${spacing.spacing16};
      flex-shrink: 0;

      & svg {
        width: 100%;
        height: 100%;
      }
    }
  `,
    compact: css `
    padding: ${spacing.spacing16};
    padding-left: ${spacing.spacing8};

    & .${BannerTags.iconWrapper} {
      margin-right: ${spacing.spacing8};
    }
  `,
    error: css `
    background-color: ${colors.strawberry100};
  `,
    info: css `
    background-color: ${colors.aqua100};
  `,
    warning: css `
    background-color: ${colors.mango100};
  `,
};
//# sourceMappingURL=common-theme.js.map